import {icon, IconParams} from "@fortawesome/fontawesome-svg-core"
import {IconDefinition} from "@fortawesome/fontawesome-common-types"

export const iconNode = (iconDefinition: IconDefinition, params: IconParams = {}) => {
  const i = icon(iconDefinition, params)
  return Array.from(i.node).map(n => {return n})
}